import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

import {LpHoldingPositionRes} from 'src/app/lp/models/LpHoldingPositionRes.model';
import {isNullOrUndefined} from 'src/app/shared/TerraUtils';
import {CurrencyModel} from 'src/app/shared/models/CurrencyModel';
import InvestmentSecurityType from '../../../../shared/enums/InvestmentSecurityType.enum';

@Component({
  selector: 'terra-holding-my-position-section',
  templateUrl: './holding-my-position-section.component.html',
  styleUrls: [
    './holding-my-position-section.component.scss',
    '../../../styles/holding/holding-page-shared.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HoldingMyPositionSectionComponent implements OnInit {
  @Input() position: LpHoldingPositionRes = new LpHoldingPositionRes();
  @Input() initialCurrency: CurrencyModel = new CurrencyModel();
  @Input() holdingSecurityType: InvestmentSecurityType;
  @Input() displayCashOnCash: boolean;
  @Input() displayIrr: boolean;
  @Input() displayEquityMultiple: boolean;
  @Input() includeUnrealizedNav: boolean;
  @Output() toDisplay = new EventEmitter<boolean>();

  InvestmentSecurityType = InvestmentSecurityType;

  constructor() {
  }

  ngOnInit(): void {
    this.displayData();
  }

  displayData() {
    this.toDisplay.next(
      !isNullOrUndefined(this.position?.principalBalance) ||
      !isNullOrUndefined(this.position?.returnToDate) ||
      !isNullOrUndefined(this.position?.totalInvested) ||
      !isNullOrUndefined(this.position?.irrPercentage) ||
      !isNullOrUndefined(this.position?.adjustedIrrPercentage) ||
      !isNullOrUndefined(this.position?.cashOnCashRatePercentage)
    );
  }
}
